import React from 'react';
import { useQuery } from '@apollo/client';
import { QUERY_ELEVES_WITH_QUIZ_TO_NTE_AND_QUIZ } from '../../graphql/query/classe/queryElevesWithQuizToNote';
import { useParams } from 'react-router-dom';
import { LoadingContainer } from '../../components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from '../../components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';
import {
  getClasseDefWithElevesQuizToNoteFromQuery,
  getQuizDefWithQuestionsAndCompetencesFromQuery
} from '../../helpers/transformApiResponse/quiz';
import { RecapQuizClasseView } from './RecapQuizClasse.view';

export const RecapQuizClasse = () => {
  const { id, classeId } = useParams<{ id: string; classeId: string }>();
  const { data, loading, error } = useQuery(
    QUERY_ELEVES_WITH_QUIZ_TO_NTE_AND_QUIZ,
    {
      variables: {
        id: classeId,
        quizId: id
      }
    }
  );
  if (loading) return <LoadingContainer />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new GraphQLError(
            'Erreur dans la récupération des données (classe ou Quiz)'
          )
        }
      />
    );

  const classe = getClasseDefWithElevesQuizToNoteFromQuery(
    data?.classe?.data?.attributes
  );
  const quiz = getQuizDefWithQuestionsAndCompetencesFromQuery(
    data?.quiz?.data?.attributes
  );

  return <RecapQuizClasseView quizId={id} quiz={quiz} classe={classe} />;
};
